import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface EditorialOffice {
    _id: string;
    fullName: string;
    email: string;
}

interface EditorialOfficeContextType {
    editorialOffice: EditorialOffice | null;
    token: string | null;
    isAuthenticated: boolean;
    logout: () => void;
    loading: boolean;
}

const EditorialOfficeContext = createContext<EditorialOfficeContextType>({
    editorialOffice: null,
    token: null,
    isAuthenticated: false,
    logout: () => { },
    loading: true
});

export const useEditorialOffice = () => useContext(EditorialOfficeContext);

export const EditorialOfficeProvider = ({ children }: { children: ReactNode }) => {
    const [editorialOffice, setEditorialOffice] = useState<EditorialOffice | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('editorialOfficeToken');
        const storedEditorialOffice = localStorage.getItem('editorialOfficeData');

        if (storedToken && storedEditorialOffice) {
            setToken(storedToken);
            setEditorialOffice(JSON.parse(storedEditorialOffice));
        }

        setLoading(false);
    }, []);

    const logout = () => {
        localStorage.removeItem('editorialOfficeToken');
        localStorage.removeItem('editorialOfficeData');
        setEditorialOffice(null);
        setToken(null);
        // This role is embedded as a tab inside the unified dashboard, so logging out
        // here should return to the unified login, not this role's standalone one.
        window.location.href = '/login';
    };

    return (
        <EditorialOfficeContext.Provider value={{
            editorialOffice,
            token,
            isAuthenticated: !!token && !!editorialOffice,
            logout,
            loading
        }}>
            {children}
        </EditorialOfficeContext.Provider>
    );
};
